var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFdouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messages/card/double"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M20.0001 10H70.0001C73.682 10 76.6667 12.9848 76.6667 16.6667V56.6667M20.0001 33.3333H30.0001M20.0001 43.3333H30.0001M20.0001 53.3333H30.0001M17.3334 66.6667H56.0001C59.7338 66.6667 61.6006 66.6667 63.0267 65.94C64.2811 65.3009 65.301 64.281 65.9401 63.0266C66.6667 61.6005 66.6667 59.7337 66.6667 56V30.6667C66.6667 26.933 66.6667 25.0661 65.9401 23.6401C65.301 22.3856 64.2811 21.3658 63.0267 20.7266C61.6006 20 59.7338 20 56.0001 20H17.3334C13.5997 20 11.7329 20 10.3068 20.7266C9.0524 21.3658 8.03253 22.3856 7.39337 23.6401C6.66675 25.0661 6.66675 26.933 6.66675 30.6667V56C6.66675 59.7337 6.66675 61.6005 7.39337 63.0266C8.03253 64.281 9.0524 65.3009 10.3068 65.94C11.7329 66.6667 13.5997 66.6667 17.3334 66.6667ZM42.6667 46.6667H50.6667C51.6002 46.6667 52.0669 46.6667 52.4234 46.485C52.737 46.3252 52.992 46.0703 53.1518 45.7567C53.3334 45.4001 53.3334 44.9334 53.3334 44V36C53.3334 35.0666 53.3334 34.5999 53.1518 34.2433C52.992 33.9297 52.737 33.6748 52.4234 33.515C52.0669 33.3333 51.6002 33.3333 50.6667 33.3333H42.6667C41.7333 33.3333 41.2666 33.3333 40.9101 33.515C40.5965 33.6748 40.3415 33.9297 40.1817 34.2433C40.0001 34.5999 40.0001 35.0666 40.0001 36V44C40.0001 44.9334 40.0001 45.4001 40.1817 45.7567C40.3415 46.0703 40.5965 46.3252 40.9101 46.485C41.2666 46.6667 41.7333 46.6667 42.6667 46.6667Z",
    stroke: "#C1C3C7",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdouble);
export default __webpack_public_path__ + "static/media/fdouble.3166b13f10af9b733134f5fc030732e7.svg";
export { ForwardRef as ReactComponent };